import { AutogenModelStandardCode, AutogenRowStandardCode } from "./autogen/AutogenModelStandardCode";

export class ModelStandardCode extends AutogenModelStandardCode<RowStandardCode> {
    constructor() {
        super(RowStandardCode);
    }
}

export class RowStandardCode extends AutogenRowStandardCode {
}